import type { FlowMedia } from '@/types';
import { MediaType } from '@/types';
import { MAGIC_FLOW_WEBHOOK_URL } from '@/consts/urls';
import { getMediaTypeFromString } from '@/hooks/useGenerate/utils';

import { pollUntilCompleted } from './pollUntilCompleted';

const getMediaFromFlowId = async (id: string): Promise<FlowMedia | null> => {
  const pollUrl = `${MAGIC_FLOW_WEBHOOK_URL}/${id}/result`;

  const { response } = await pollUntilCompleted({ url: pollUrl });

  if (!response || !response.result || response.result.length === 0) {
    return null;
  }

  const firstResult = response.result[0];
  const resultType = firstResult?.type?.toLowerCase();
  const mediaType = getMediaTypeFromString(resultType);
  const isVideo = mediaType === MediaType.VIDEO;
  const posterUrl = isVideo ? firstResult.result?.frames?.first : undefined;

  return {
    id,
    type: mediaType,
    url: firstResult.result?.url,
    width: firstResult.result?.metadata?.width,
    height: firstResult.result?.metadata?.height,
    driveUid: firstResult.driveUid,
    poster: posterUrl,
  };
};

export { getMediaFromFlowId };
